import React, { useState, useEffect } from 'react';

function TickerItem({ item }) {
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    const iv = setInterval(() => {
      setElapsed(Math.floor((Date.now() - new Date(item.startedAt).getTime()) / 1000));
    }, 1000);
    return () => clearInterval(iv);
  }, [item.startedAt]);

  const statusColors = { dialing: 'dialing', answered: 'answered', transfer: 'transfer', ringing: 'ringing' };
  const cls = statusColors[item.status] || 'dialing';
  const statusLabels = { dialing: 'COMPOSITION…', answered: 'EN APPEL', transfer: 'TRANSFERT', ringing: 'SONNERIE' };

  return (
    <div className="ticker-item">
      <span className={`ticker-dot ${cls}`} />
      <span className="ticker-phone">{item.phone}</span>
      <span className="ticker-status">{statusLabels[item.status] || item.status?.toUpperCase()}</span>
      <span className="ticker-time">{elapsed}s</span>
    </div>
  );
}

export default function DialingTicker({ liveDialing, totalDialing, fullUI }) {
  if (!liveDialing.length) {
    return (
      <div className="ticker-wrap" style={{ color: 'var(--muted)', fontSize: 11, fontStyle: 'italic' }}>
        <span style={{ marginRight: 12, fontSize: 11, fontWeight: 700, color: 'var(--cyan)', letterSpacing: '0.06em' }}>
          ◉ COMPOSITION EN COURS {totalDialing > 0 ? totalDialing : 0}
        </span>
        Aucune composition en cours
      </div>
    );
  }

  // Simplified view: the ticker lists every dial in the campaign — including
  // leads being bridged to OTHER agents, which this agent cannot act on. Show
  // a single count instead of the per-call rows.
  if (!fullUI) {
    return (
      <div className="ticker-wrap" style={{ color: 'var(--muted)', fontSize: 11 }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--cyan)', letterSpacing: '0.06em' }}>
          ◉ COMPOSITION EN COURS {liveDialing.length}
        </span>
      </div>
    );
  }

  return (
    <div className="ticker-wrap">
      <span style={{ marginRight: 8, fontSize: 11, fontWeight: 700, color: 'var(--cyan)', letterSpacing: '0.06em', flexShrink: 0 }}>
        ◉ EN DIRECT {liveDialing.length}
      </span>
      {liveDialing.map(item => (
        <TickerItem key={item.id || item.phone} item={item} />
      ))}
    </div>
  );
}
